import React from "react";

type propsCargando = {
    mensaje?:string
}
const Cargando = (props:propsCargando) => {
    return (
        <div style={{ textAlign: "center" }}>
            <i className="fas fa-sync fa-spin"></i>
            {props.mensaje && 
                <em> {props.mensaje}</em>
            }
            {
                !props.mensaje &&
                <em> Cargando</em>
            }
        </div>

    )
}
export default Cargando;